import HeaderSubSection from "../../components/HeaderSubSection/index.vue";
// import articleModal from "../../components/articleModal/index.vue";
import articlesSection from "../../components/articlesSection/index.vue";
export default {
  name: "articlesPage",
  components: {
    HeaderSubSection,
    // articleModal,
    articlesSection,
  },
};
